// dataAroInsightsSlice.js

import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "dataAroInsights",
    initialState: {
        status: "idle",
        data: {},
        hotelID: null,
        error: null,
    },
    reducers: {
        loading_AroInsights: (state, action) => {
            state.status = "loading";
            state.data = {};
            state.hotelID = action.payload.hotelID;
            state.error = null;
        },
        load_AroInsights: (state, action) => {
            state.status = "loaded";
            state.data = action.payload.data;
            state.hotelID = action.payload.hotelID;
            state.error = null;
        },
        error_AroInsights: (state, action) => {
            state.status = "error";
            state.data = {};
            state.hotelID = action.payload.hotelID;
            state.error = action.payload.error;
        },
    },
});

export default slice.reducer;

export const { loading_AroInsights, load_AroInsights, error_AroInsights } =
    slice.actions;
